import type { SxProps, Theme } from '@mui/material';

export const containerSx: SxProps<Theme> = {
  fontFamily: 'Archivo',
  textAlign: 'left',
  '& h2': {
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '29px',
    letterSpacing: '0em',
    mt: '26px',
  },
};

export const uploaderWrapperSx: SxProps<Theme> = {
  width: '100%',
  mt: '22px',
  mb: '24px',
};

export const contentSx: SxProps<Theme> = {};
